//@flow
import {commaFormat} from '../../../../utils/number';

import type {SinglePromotion, Currency} from '../../../../entities';

export const getTerms = (
  promotion: SinglePromotion,
  currency: Currency
): string => {
  if (promotion.promotionScope === 'SHIPPING') {
    return 'La promoción aplica al costo de envío o costo de recojo, sera reflejado en el siguiente paso';
  }

  let terms = '';
  if (
    promotion.promotionType === 'BUYANDPAY' &&
    typeof promotion.buyQuantity === 'number' &&
    typeof promotion.payQuantity === 'number'
  ) {
    terms = `${promotion.buyQuantity}x${promotion.payQuantity} en ${
      promotion.promotionMode === 'ALL'
        ? 'todos los productos'
        : promotion.promotionMode === 'SPECIFIC'
        ? 'productos seleccionados'
        : 'productos de categorias específicas'
    }`;
  }

  if (
    promotion.promotionType === 'PERCENTAGE' &&
    promotion.discountPercentage
  ) {
    terms = `${terms}, ${Number(
      promotion.discountPercentage
    )}% de descuento en ${
      promotion.promotionMode === 'ALL'
        ? 'todos los productos'
        : promotion.promotionMode === 'SPECIFIC'
        ? 'productos seleccionados'
        : 'productos de categorias específicas.'
    }`;
  }

  terms = promotion.enabledOnOfferPrice
    ? `${terms}, Aplica sobre precios en oferta y al por mayor`
    : `${terms}, No aplica sobre precios de oferta ni al por mayor`;

  terms = promotion.enabledInteractWithOtherPromotions
    ? `${terms}, De haber dos a más promociones, se aplica la de mayor descuento para
      el cliente`
    : `${terms}, No aplica en conjunto con otras promociones`;

  if (typeof promotion.minQuantity === 'number') {
    terms = `${terms}, Requerimiento mínimo: mínimo ${promotion.minQuantity} productos`;
  }

  if (promotion.minAmount) {
    const minAmount = commaFormat(
      promotion.minAmount,
      currency ? currency.symbol : ''
    );
    terms =
      promotion.promotionType !== 'BUYANDPAY'
        ? `${terms}, Requerimiento mínimo: compras mayores a ${minAmount}`
        : `${terms}, Aplicar sobre un monto mayor a ${minAmount}`;
  }

  if (
    promotion.promotionType === 'BUYANDPAY' &&
    typeof promotion.maxUses === 'number'
  ) {
    terms = `${terms}, Máximo de usos por orden: ${promotion.maxUses}`;
  }

  if (promotion.maxAmount) {
    const maxAmount = commaFormat(
      promotion.maxAmount,
      currency ? currency.symbol : ''
    );
    terms = `${terms} Monto máximo de descuento por orden ${maxAmount}`;
  }

  return terms;
};
